export default function _isFunction(x) {
  return Object.prototype.toString.call(x) === '[object Function]';
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isFunction.js
// module id = 158
// module chunks = 1